import { IUserProfilePicture } from 'app/projects/user/src/lib/interfaces/user-profile-picture.interface';
import { IListingBookingRequestApproverQuery } from '../interfaces/listing-booking-request-approver.query.interface';

export class ListingBookingRequestApprover {
    id: string;
    firstName: string;
    lastName: string;
    team: string;
    profilePicture: IUserProfilePicture | null;

    constructor(query: IListingBookingRequestApproverQuery) {
        this.id = query.id.toString();
        this.firstName = query.first_name;
        this.lastName = query.last_name;
        this.team = query.team;
        this.profilePicture = query.profile_picture || null;
    }

    get fullName(): string {
        return `${this.firstName} ${this.lastName}`.trim();
    }

    get displayNameWithTeam(): string {
        return this.team ? `${this.fullName} (${this.team})` : this.fullName;
    }
}
